<template>
    <div class="pa-0 ma-0">
        <v-row class="row mb-2">
            <v-col cols="12" :class="{ 'px-2': is_mobile, 'py-0': true }">
                <label class="input-label label-base">Razón social</label>
                <v-autocomplete
                    autocomplete="off"
                    outlined
                    dense
                    hide-details
                    return-object
                    :value="value"
                    :items="items"
                    :readonly="readonly"
                    :loading="loading"
                    :item-text="getItemText"
                    :item-value="item => item && item.id"
                    :search-input.sync="search"
                    :filter="filterBy"
                    :no-data-text="'No se han encontrado coincidencias'"
                    :error="showErrors && isPartyIncomplete"
                    :background-color="showErrors && isPartyIncomplete ? '#DC0B0B1A' : 'white'"
                    @input="onInput"
                    @change="onChange"
                >
                    <template slot="item" slot-scope="data">
                        <span>{{ getItemDisplay(data.item) }}</span>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>

        <v-row class="label-cif">
            <v-col cols="7" md="5" lg="4" :class="{ 'px-2': is_mobile, 'py-0': true }">
                <AppTextFieldV2
                    class="mr-1 label-base"
                    label="CIF"
                    :value="value ? value.cif : ''"
                    :readonly="true"
                    :error="showErrors && !hasCif"
                    :background_color="showErrors && !hasCif ? '#DC0B0B1A' : 'white'"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import AppTextFieldV2 from '@/modules/widgets/infra/AppTextFieldV2.vue'

export default {
    name: 'SupplierReceptorSelector',
    components: { AppTextFieldV2 },
    props: {
        value: {
            type: Object,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        invoiceable_repo: {
            type: Object,
            required: false,
            default: null,
        },
        company_id: {
            type: [Number, String],
            required: false,
            default: null,
        },
        showErrors: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            items: [],
            search: null,
            loading: false,
            api_call: 0,
            searchTimeout: null,
        }
    },
    computed: {
        is_mobile() {
            return this.$vuetify.breakpoint.smAndDown
        },
        hasCif() {
            return !!(this.value && this.value.cif)
        },
        isPartyIncomplete() {
            return !this.value || !this.value.cif
        },
    },
    methods: {
        getItemText(item) {
            if (!item) return ''
            if (item.type === 'fisica') {
                return item.name || ''
            }
            return item.business_name || item.name || ''
        },
        getItemDisplay(item) {
            const label = this.getItemText(item)
            const cif = item && item.cif ? item.cif : ''
            return cif ? `${label} — ${cif}` : label
        },
        onInput(selected) {
            this.$emit('input', selected)
        },
        onChange(selected) {
            console.debug('[SupplierReceptorSelector] update_party', selected)
            this.$emit('update_party', selected)
        },
        async fetchItems(term) {
            if (!this.invoiceable_repo || !this.company_id) {
                this.items = []
                return
            }
            this.loading = true
            this.api_call += 1
            const callId = this.api_call
            try {
                const results = await this.invoiceable_repo.get_supplier_list(this.company_id, term || '')
                if (callId !== this.api_call) return
                this.items = results || []
                if (this.value && !this.items.some(item => item.id === this.value.id)) {
                    this.items.push(this.value)
                }
            } catch (err) {
                console.error('Error loading suppliers:', err)
            } finally {
                if (callId === this.api_call) {
                    this.loading = false
                }
            }
        },
        filterBy(item, queryText) {
            if (!queryText) return true
            const q = queryText.toLowerCase()
            const cif = (item.cif || '').toLowerCase()
            if (cif.includes(q)) return true
            if (item.type === 'fisica') {
                const first = (item.first_surname || '').toLowerCase()
                const second = (item.second_surname || '').toLowerCase()
                const name = (item.name || '').toLowerCase()
                const fullName = `${first} ${second} ${name}`
                return first.includes(q) || second.includes(q) || name.includes(q) || fullName.includes(q)
            }
            const business = (item.business_name || '').toLowerCase()
            const trade = (item.trade_name || '').toLowerCase()
            return business.includes(q) || trade.includes(q)
        },
    },
    mounted() {
        if (this.value && !this.items.some(item => item.id === this.value.id)) {
            this.items = [this.value]
        }
        this.fetchItems('')
    },
    watch: {
        value(val) {
            if (val && Object.keys(val).length > 0) {
                if (!this.items.some(item => item.id === val.id)) {
                    this.items = [val, ...this.items]
                }
            }
        },
        search(val) {
            if (this.value && val === this.getItemText(this.value)) return
            if (this.searchTimeout) clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => { this.fetchItems(val || '') }, 300)
        },
    },
    beforeDestroy() {
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
    },
}
</script>